// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DzzWg","col":"styles_col__1EcQp"};